export const navigateWithFilters = (navigate, filters) => {
  const params = new URLSearchParams();
  
  if (filters.filter) params.append('filter', filters.filter);
  if (filters.status) params.append('status', filters.status);
  if (filters.department_id) params.append('department_id', filters.department_id);
  if (filters.area_id) params.append('area_id', filters.area_id);
  if (filters.priority) params.append('priority', filters.priority);
  if (filters.responsible_user_id) params.append('responsible_user_id', filters.responsible_user_id);
  if (filters.weekStart) params.append('weekStart', filters.weekStart);
  if (filters.weekEnd) params.append('weekEnd', filters.weekEnd);
  
  const queryString = params.toString();
  navigate(`/tasks${queryString ? '?' + queryString : ''}`);
};